import { Box, Typography } from '@mui/material'
import GooglePlayButton from '../components/GooglePlayButton';

const Footer = () => {
  const links = [
    {name: 'Instagram', path: 'https://www.instagram.com/cyberbadge'},
    {name: 'LinkedIn', path: 'https://www.linkedin.com/in/bogdan-panov'},
    {name: 'Hackerspace Pomorze', path: 'https://hsp.sh'}
  ];

  return (
    <Box sx={{
      width: "100%",
      display: "flex",
      alignItems: "center",
      flexDirection: "column",
      background: "#f5f4f3",
      px: {xs: "5vw", sm:"10vw"}, 
      py: {xs: "1rem"}, 
      margin: "0 auto"
    }}>
      <Typography
        variant="h6"
        noWrap
        component="a"
        href="/"
        sx={{marginBottom: "1rem"}}
      >
        CYBERBADGE
      </Typography>
      <GooglePlayButton />
      <Typography sx={{ my: "1rem"}}>
      If you have any questions or feedback, drop us a line at <Typography component="a" href="mailto:info@cyberbadge.net" sx={{fontWeight: "600"}}>info@cyberbadge.net</Typography>
      </Typography>
      <Typography>
        Stay up-to-date on the latest updates at
      </Typography>
      <Typography sx={{ marginBottom: "1rem", display: "flex", flexWrap: "wrap", justifyContent: {xs: "space-around", sm: 'center'}}}>
        {links.map((link) => (
          <Typography
            variant="body1"
            component="a"
            href={link.path}
            target="_blank"
            sx={{ mx: {xs: "auto", sm: "1rem"}, display: "inline", my: "auto", fontWeight: "600", marginBottom: "1rem" }}
          >
            {link.name}
          </Typography>
        ))}
      </Typography>
      <Typography sx={{color: "rgba(0, 0, 0, 0.6)", fontSize: "0.8rem"}}>
      2023 CyberBadge
      </Typography>
    </Box>
  )
}

export default Footer